export default __webpack_public_path__ + "static/media/PawsnPals.27b91ce2.png";